export const AUTH_STORAGE_KEY = 'authData';

export const AUTH_EXPIRY_MS = 24 * 60 * 60 * 1000;

export const AUTH_CASES = {
  NONE: 'NONE',
  EXPIRED: 'EXPIRED',
  VALID: 'VALID',
} as const;

export const USER_FIELDS = {
  LINK_ACCOUNT: 'link_account',
  ZIP_CODE: 'zip_code',
} as const;

export const MISSING_AUTH_ERROR = 'No authentication data in local storage.';
